module.exports = __webpack_public_path__ + "static/media/msg-reply.5a3dccdd.png";